import Axios, { AxiosInstance, AxiosRequestConfig } from "axios";
import Cookies from "js-cookie";

const setAuthTokenToHeaderIntercepter = (config: AxiosRequestConfig) => {
  const token = Cookies.get("token");
  if (token === undefined) {
    console.error("token が cookie にセットされていまいせん。");
  } else {
    config.headers.Authorization = token;
  }
  return config;
};

const createAxios: () => AxiosInstance = () => {
  const instance = Axios.create();
  instance.interceptors.request.use(setAuthTokenToHeaderIntercepter);
  return instance;
};

const axios = createAxios();
export default axios;
